import * as React from 'react';

const Average = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
		<path stroke='#343434' strokeWidth={2} d='m17.5 15 3.5-3.5L17.5 8M3 11.5h18' />
	</svg>
);
export default Average;
